import clsx from "clsx";
import { AccessibleSVG } from "components";
import { stepIconStyle } from "./step-icon-style";

export interface StepIconProp {
  title: string;
  active: boolean;
  completed: boolean;
  icon: any;
}

export const StepIcon = ({ title, active, completed, icon }: StepIconProp) => {
  const classes = stepIconStyle();

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {completed ? (
        <AccessibleSVG
          className={`MuiSvgIcon-root ${classes.iconSize}`}
          id={`icon-${icon}`}
          title={`${title} Completed`}
        >
          <path
            fill="currentColor"
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
          ></path>
        </AccessibleSVG>
      ) : (
        <AccessibleSVG
          className={`MuiSvgIcon-root ${active ? classes.iconSize : ""}`}
          id={`icon-${icon}`}
          title={`${title} ${active ? "Active" : "Inactive"}`}
        >
          {active ? (
            <path
              fill="currentColor"
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2M7 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5m5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5m5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5"
            ></path>
          ) : (
            <circle fill="currentColor" cx="12" cy="12" r="12" />
          )}
        </AccessibleSVG>
      )}
    </div>
  );
};
